"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChainedProvider = void 0;
const GeocodingProvider_1 = require("./GeocodingProvider");
class ChainedProvider extends GeocodingProvider_1.default {
    constructor(providers, settings) {
        super("Chained(" + providers.map(p => p.provider.name).join(", ") + ")");
        this.providers = [];
        this.providers = providers;
        this.settings = settings !== null && settings !== void 0 ? settings : { maxResults: 10, maxReverseDistance: 50 };
    }
    forward(query, callback) {
        this.forwardWith(0, [], query, callback);
    }
    forwardWith(p, previousResults, query, callback) {
        const provider = this.providers[p];
        let chain = provider.chainForward;
        if (!chain) {
            chain = (previousResults, results) => {
                if (results.length == 0) {
                    return { next: true, results: previousResults };
                }
                let chained = previousResults.concat(results);
                chained.sort((x, y) => {
                    if (x.score > y.score)
                        return -1;
                    return 1;
                });
                return { next: true, results: chained };
            };
        }
        provider.provider.forward(query, results => {
            const chained = chain(previousResults, results);
            if (chained.next && p < this.providers.length - 1) {
                this.forwardWith(p + 1, chained.results, query, callback);
            }
            else {
                let results = chained.results;
                if (results.length > this.settings.maxResults) {
                    results = results.slice(0, this.settings.maxResults);
                }
                results.sort((x, y) => {
                    if (x.score > y.score)
                        return -1;
                    return 1;
                });
                callback(results);
            }
        });
    }
    reverse(l, callback) {
        this.reverseWith(0, [], l, callback);
    }
    reverseWith(p, previousResults, l, callback) {
        const provider = this.providers[p];
        let chain = provider.chainReverse;
        if (!chain) {
            chain = (l, previousResults, results) => {
                if (results && results.length > 0) {
                    return { next: false, results: results };
                }
                else {
                    const hasNext = p != this.providers.length;
                    // move to next provider.
                    return { next: hasNext, results: [] };
                }
            };
        }
        provider.provider.reverse(l, results => {
            const chained = chain(l, previousResults, results);
            if (chained.next && p < this.providers.length - 1) {
                this.reverseWith(p + 1, chained.results, l, callback);
                return;
            }
            else {
                let results = chained.results;
                if (results.length > this.settings.maxResults) {
                    results = results.slice(0, this.settings.maxResults);
                }
                results.sort((x, y) => (x.distance > y.distance) ? -1 : 1);
                for (let i = 0; i < results.length; i++) {
                    if (results[i].distance > this.settings.maxReverseDistance) {
                        results[i].description = `${results[i].location.lng},${results[i].location.lat}`;
                    }
                }
                callback(results);
            }
        });
    }
}
exports.ChainedProvider = ChainedProvider;
